@if (answer && (!trace || traceNotAvailable)) {
<div class="not-available">
  {{ "taxReturns.calculation-trace-not-available-for-this-answer" | transloco }}
</div>
}

<div class="chart-container" #chartContainer (click)="selectedNode = null">
  @for (chart of charts; track chart) {
  <div
    class="chart"
    [ngClass]="{ selected: !!selectedNode }"
    [ngStyle]="{ width: chart.width + 'px', height: chart.height + 'px' }"
  >
    @for (e of chart.edges; track edgeTrackBy($index, e)) {
    <div class="edge {{ e.cssClass }}" [ngStyle]="e.style">
      <div class="edge-bg"></div>
    </div>
    } @for (n of chart.nodes; track nodeTrackBy($index, n)) {
    <div
      class="node"
      [class]="n.instruction.block.type.toLowerCase()"
      [ngClass]="{
        selected: n === selectedNode,
        'missing-info-warning':
          n.instruction.block.id === 'warning-missing-info'
      }"
      [ngStyle]="n.style"
      (click)="selectTraceNode(chart, n); $event.stopPropagation()"
    >
      <div class="highlight-bg"></div>
      <div class="bg"></div>
      <span class="text">{{ n.instruction.name }}</span>
      @if (n.instruction.block.type === BlockType.Value ||
      n.instruction.block.type === BlockType.End) {
      <div class="complexity-icons-container">
        <div class="complexity-icons">
          @for (complexity of [n.instruction.complexityPreparer,
          n.instruction.complexityReviewer1, n.instruction.complexityReviewer2];
          track complexity) {
          <div
            class="complexity-icon"
            [ngClass]="{
              'complexity-low': complexity == 1,
              'complexity-medium': complexity == 2,
              'complexity-high': complexity == 3
            }"
          ></div>
          }
        </div>
      </div>
      }
    </div>
    }
  </div>
  }
</div>

@if (selectedNode) {
<div class="trace-info">
  <div class="block-type">{{ selectedNode.instruction.block.type }}</div>
  <div class="instruction-name">{{ selectedNode.instruction.name }}</div>
  <div class="block-name tag dark">
    {{ selectedNode.instruction.block.name }}
  </div>
  @if (selectedNode.instruction.description) {
  <div class="description">
    <div class="subheading">Description</div>
    <div class="content">
      {{ selectedNode.instruction.description }}
    </div>
  </div>
  }
  <div class="input-heading">{{ "taxReturns.input" | transloco }}</div>
  <div class="input-table">
    <div class="header-row">
      <div>{{ "taxReturns.name" | transloco }}</div>
      <div>{{ "taxReturns.value" | transloco }}</div>
    </div>
    @for (input of selectedNode.traceInputs; track input; let index = $index) {
    <div class="data-row">
      <div
        class="name"
        (click)="
          selectCalcInput(
            selectedChart,
            selectedNode,
            selectedNode.instruction.inputs[index]
          )
        "
      >
        {{
          getInputName(
            selectedChart,
            selectedNode,
            selectedNode.instruction.inputs[index]
          )
        }}
        @if (InputLinktoQuestion(selectedNode.instruction.inputs[index])) {
        <div class="icon-wrapper">
          <a
            class="view"
            role="link"
            [routerLink]="
              navigateToQuestion(selectedNode.instruction.inputs[index]).href
            "
            [queryParams]="
              navigateToQuestion(selectedNode.instruction.inputs[index]).query
            "
          >
            <i class="icon external alternate"></i>
          </a>
          <i
            class="icon search alternate"
            (click)="
              showViewAnswerModal(selectedNode.instruction.inputs[index])
            "
          ></i>
        </div>
        }
      </div>
      <div
        class="value"
        [ngClass]="{ resolved: input.resolved, unresolved: !input.resolved }"
        [title]="!input.resolved ? unresolvedInputText : undefined"
      >
        @if (isArray(input.value)) { @for (nestedValue of input.value; track
        nestedValue) { @if (isArray(nestedValue)) {
        <div class="input-array">
          @for (nestedValue2 of nestedValue; track nestedValue2) {
          <div>
            {{ formatValue(nestedValue2) }}
          </div>
          }
        </div>
        } @if (!isArray(nestedValue)) {
        <div>
          {{ formatValue(nestedValue) }}
        </div>
        } } } @if (!isArray(input.value)) {
        <div>
          {{ formatValue(input.value) }}
        </div>
        }
      </div>
    </div>
    }
  </div>
  <div class="output-heading">{{ "taxReturns.output" | transloco }}</div>
  <div
    class="output-value"
    [ngClass]="{
      resolved: selectedNode.traceOutput.resolved,
      unresolved: !selectedNode.traceOutput.resolved
    }"
    [title]="
      !selectedNode.traceOutput.resolved ? unresolvedOutputText : undefined
    "
  >
    @if (isFinalOutput()) {
    {{ formatFinalOutput(selectedNode.traceOutput.value) }}
    } @if (!isFinalOutput()) {
    {{ selectedNode.traceOutput.value }}
    }
  </div>
  @if (isFinalOutput() && !!answer.overrideStatus) {
  <div class="output-heading">
    {{ "taxReturns.manual-output-override" | transloco }}
  </div>
  @if (!isEmpty(answer.answer)) {
  <div class="output-value">{{ question | answerDisplay: answer.answer }}</div>
  } @if (isEmpty(answer.answer)) {
  <span class="empty">{{ "taxReturns.empty" | transloco }}</span>
  } }
</div>
} @if (question && answer && !selectedNode) {
<div class="trace-info">
  @if (!traceNotAvailable) { @if (trace) {
  <div class="output-heading">
    {{ "taxReturns.final-calc-output" | transloco }}
  </div>
  } @if (trace) {
  <div class="output-value">
    @if (!isEmpty(finalCalcOutput)) {
    <span>{{ formatFinalOutput(finalCalcOutput) }}</span>
    } @if (isEmpty(finalCalcOutput)) {
    <span class="empty">{{ "taxReturns.empty" | transloco }}</span>
    }
  </div>
  } } @if (!!answer.overrideStatus) {
  <div class="output-heading">
    {{ "taxReturns.manual-output-override" | transloco }}
  </div>
  @if (!isEmpty(answer.answer)) {
  <div class="output-value">{{ question | answerDisplay: answer.answer }}</div>
  } @if (isEmpty(answer.answer)) {
  <span class="empty">{{ "taxReturns.empty" | transloco }}</span>
  } }
</div>
}

<div id="modals-container">
  <div #viewAnswer id="view-answer" class="ui modal">
    <div class="icon modal-close close"></div>

    <div class="content">
      <h3>
        {{ isClientRulesViewModal ? clientRulesCategory : subCategoryName }}
      </h3>
    </div>
    @if (subGroup && !subGroup?.hidden && !isClientRulesViewModal) {
    <app-question-group-card
      [hidden]="isFullScreenMode && fullScreenSubGroup.id !== subGroup.id"
      [formGroup]="group?.deleted ? group.deletedFormGroup : group?.formGroup"
      [subGroup]="subGroup"
      [groupId]="group.id"
      [isActive]="true"
      [deleted]="group?.deleted"
      [isVisible]="activeGroup?.id === group?.id"
      [inspectMode]="
        (tab == 3 && 'flag') ||
        (rightSideTab == 'calculation' && 'trace') ||
        null
      "
      [modernTable]="true"
      [isFullScreenMode]="isFullScreenMode"
      [fullScreenSubGroup]="fullScreenSubGroup"
      [chartRequested]="chartRequested"
      (toggleFullScreen)="handleToggleFullScreen($event)"
      (handleAside)="handleSideOpen($event)"
      [sideOpen]="sideOpen"
      [debugMode]="debug"
      [taxReturnId]="taxReturn.id"
      [labelClick]="answerSelected"
      [hideEmptyQuestions]="false"
      [hideClearOverRideQuestionIcon]="true"
      (refreshTaxReturn)="(true)"
      (loadTrace)="loadTrace($event)"
      (selectSubgroup)="selectSubgroup(subGroup)"
      [inputQuestionId]="inputQuestionId"
    >
    </app-question-group-card>
    } @if (isClientRulesViewModal) {
    <div id="questions">
      @for (question of categoryRules?.clientQuestions | orderBy: 'order'; track
      question) { @if (question.displayFieldType !== 'table' &&
      !question.parentId) {
      <div (click)="selectField(question)">
        @if (question) {
        <app-form-field-wrapper
          [formGroup]="this.categoryRules?.formGroup"
          [questions]="categoryRules.clientQuestions"
          [question]="question"
          [showHiddenQuestion]="showHiddenQuestions"
          [inputQuestionId]="inputQuestionId"
        >
        </app-form-field-wrapper>
        }
      </div>
      } @if (question.displayFieldType === 'table') {
      <div [hidden]="question.hidden && !showHiddenQuestions" class="table-q">
        <div class="table-label" (click)="selectField(question)">
          <div style="flex:1">
            <label>{{ question.question }}</label>
          </div>
          <div>
            <div
              [hidden]="!question.rows || question.rows.length === 0"
              (click)="canEditClientRules() && setGlobal(question)"
              class="icon globe"
              [ngClass]="{
                disabled: !question?.isGlobal,
                'prevent-click': categoryRules.id && question?.isGlobal
              }"
            ></div>
            <div class="ui inverted popup" *transloco="let t">
              {{
                question?.isGlobal
                  ? t(
                      "clients.this-answer-is-global-across-all-populations-for-this-client"
                    )
                  : t(
                      "clients.click-to-save-answer-to-all-populations-for-this-client"
                    )
              }}
            </div>
          </div>
        </div>
        <div class="table-group">
          <div #tableCont class="table-container">
            <table #table cellpadding="0" cellspacing="0" class="sticky-header">
              <thead>
                <tr>
                  <td (click)="newRow(question)" class="row-num">
                    <div class="add icon" title="Add New Row"></div>
                  </td>
                  @for (_question of question.questions; track _question) { @if
                  (!_question.hidden && !showHiddenQuestions) {
                  <td
                    title="{{
                      _question?.mandatory
                        ? 'This column is mandatory'
                        : undefined
                    }}"
                    [ngClass]="{
                      'checkbox-column': isBooleanCheckboxColumn(_question),
                      highlight: inputQuestionId === _question?.id
                    }"
                    (click)="selectField(_question)"
                  >
                    @if (showQuestionId) {
                    <span>{{ _question?.id }}.</span>
                    } {{ _question?.question }}
                  </td>
                  } }
                </tr>
              </thead>
              <tbody>
                @for (rowAnswer of question.rows; track rowAnswer; let index =
                $index) {
                <tr>
                  <td class="row-num" align="center">{{ index + 1 }}</td>
                  @for (cell of getTableCells(index, question); track
                  tableCellsTrackBy($index, cell)) {
                  <td
                    title="Click to edit answer"
                    id="cell-{{ question.id }}-{{ cell.question?.id }}-{{
                      index
                    }}"
                    (click)="focusTableInput(question, cell, index)"
                    [ngClass]="{
                      active: cell.answer?.isActive,
                      'checkbox-column': isBooleanCheckboxColumn(cell.question),
                      error:
                        cell.question.mandatory &&
                        !cell.formControl?.value && !cell.answer.answer
                    }"
                  >
                    @if (!cell.answer?.isActive) {
                    <div
                      class="answer"
                      [ngClass]="{
                        checkbox: isBooleanCheckboxColumn(cell.question)
                      }"
                    >
                      @if (!isBooleanCheckboxColumn(cell.question)) {
                      <div class="value">
                        {{ cell.question | answerDisplay: cell.displayAnswer }}
                      </div>
                      } @if (isBooleanCheckboxColumn(cell.question)) { @if
                      (cell.formControl? cell.formControl.value :
                      cell.answer.answer==='true') {
                      <div class="blue tick icon"></div>
                      } @if (cell.formControl? !cell.formControl.value :
                      cell.answer.answer !=='true') {
                      <div class="grey circle outline icon"></div>
                      } }
                      <div>
                        @if (!inspectMode &&
                        !isBooleanCheckboxColumn(cell.question)) {
                        <i class="pencil icon"></i>
                        }
                      </div>
                    </div>
                    } @if (cell.answer?.isActive) {
                    <div>
                      @if (cell.formControl) {
                      <app-form-field-wrapper
                        [formGroup]="this.categoryRules?.formGroup"
                        [questions]="question?.questions"
                        [question]="cell.question"
                        [row]="index"
                      ></app-form-field-wrapper>
                      }
                    </div>
                    }
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      } }
    </div>
    }
  </div>
</div>
